export default "__VITE_ASSET__CI3R0LuX__"